import { client } from '../../../../../common-utils/libraries/axios/axios';
import { CONTRACTS } from '../apiUrls';


const mutationAddContractByApiKey = (onSuccess, onError) => {
    return {
        mutationFn: ({ apiKey, labelTicketTpe, contractsAccessId, application }) => {
            return client.post(CONTRACTS.ADD_API_KEY.url, { apiKey, labelTicketTpe, contractsAccessId, application });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationAddContractByApiKey;